// ============================================================================
// ENGLISH TRANSLATIONS - CHAPTER 8: THE SHELTER OF THE MOST HIGH (BONUS)
// ============================================================================
// Level 92 (1 bonus level, 3 questions)

export const chapter8Translations = {
  name: "The Shelter of the Most High",
  description: "He who dwells in the shelter of the Most High will rest in the shadow of the Almighty",
  
  spiritualWisdom: {
    principle: "You have reached the top of the mountain, and knowledge is acquired",
    scripture: "He who dwells in the shelter of the Most High will rest in the shadow of the Almighty (Psalm 91:1)",
    application: "Unshakeable faith requires life experience, mercy and true love of Jesus. Trials will test your heart, the true path chosen."
  },
  
  levels: {
    92: {
      name: "The Shelter of the Most High",
      challenge: "You are at the top of the mountain... But unshakeable faith begins now...",
      easy: {
        question: "Who is Jesus to you personally?",
        options: [
          "A simple prophet",
          "My Lord and personal Savior",
          "A legend",
          "A philosopher"
        ],
        hint: "He is the one who gives his life to save us",
        funFact: "✝️ Jesus is God! He is not just a historical figure - He is alive and desires a personal relationship with each of us!"
      },
      medium: {
        question: "Why does fasting like Daniel help us hear God better?",
        options: [
          "To lose weight",
          "To deprive ourselves of what we love and have a transformed heart",
          "To impress others",
          "To be stronger"
        ],
        hint: "Deprive yourself of what you love most, in calm and wisdom",
        funFact: "🙏 Spiritual fasting prepares our heart for deep transformations - often painful - that bring us closer to God!"
      },
      hard: {
        question: "What is the heart's true response to all this acquired knowledge?",
        options: [
          "I am now perfect",
          "I give you my heart Jesus and I desire to be baptized",
          "I know better than others",
          "I no longer need help"
        ],
        hint: "True faith leads to total surrender and commitment to Jesus",
        funFact: "🌟✨ You have reached the top of the mountain, and knowledge is acquired ✨\n\n💖 Unshakeable faith requires life experience, mercy and true love of Jesus 💖\n\n🔥 Life's various trials will test your way, the true path we choose, our heart 🔥\n\n😔 We remain imperfect, our desires are many, and love of gain or personal comfort too often becomes our selfish priority 😔\n\n🙏 Ask God for wisdom, his love, his strength, and humbly acknowledge your weaknesses, for nothing can be hidden from Him... Nothing 🙏\n\n🥖 Fast like Daniel: deprive yourself for a moment of what you love most, in calm and wisdom 🥖\n\n💫 This will allow you to better hear God, to have a heart disposition ready for deep transformations 💫\n\n🌙 Then dreams and visions will become clearer, like for Joseph 🌙\n\n⚠️ Guard against pride: don't give in to 'I'm always right' or 'I know better' ⚠️\n\n🎁 For God's revelation is extraordinary grace 🎁\n\n💝 Having faith means entering into a free relationship and journey of the heart 💝\n\n🦸‍♂️ It will make you powerful heroes, capable of the impossible 🦸‍♂️\n\n✝️ At the summit of knowledge, the sincere heart says: 'I give you my heart Jesus and I desire to be baptized' ✝️\n\n🏔️ You have reached the top of the mountain, hold on, persevere! 🏔️\n\n⬇️ You must come down and carry this precious treasure: the hope of eternal life ⬇️\n\n🏆✨ CONGRATULATIONS! WE ARE PROUD OF YOU ✨🏆\n🌟 COURAGE VALIANT BEARER OF PEACE 🌟\n🕊️✨ MAY GOD BLESS YOU ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;